import { SocialFriendsList } from './Temp/SocialFriendsList';
import { SocialButton } from './Temp/SocialButton';
import { SocialService } from '../SocialService';
import { Inject } from '@denishussar/html5-game-engine';
import { FirebaseCloudDB } from '../../../Services/CloudDB/FirebaseCloudDB';

interface IUserData {
    first_name: string,
    last_name: string,
    id: number,
    access_token: string
}

export class VkUI extends PIXI.Container {
    // private APP_ID = 7982066;
    // private GROUP_ID = 462084990;
    // private GAME_LINK = 'https://vk.com/app7979319_676657198';

    private _user: IUserData;
    private _cont = new PIXI.Container();
    private _friendList = new SocialFriendsList();

    constructor(@Inject private service: SocialService,
                @Inject private db: FirebaseCloudDB) {
        super();
        this.init();
    }

    private async init() {

        this.addChild(this._cont);
        this._cont.visible = false;

        /*const appInit = await this.initApp();
        console.log('[VK Init]', appInit)

        const auchTocken = await this.getAuthToken();
        console.log('[VK acces_tocken]', auchTocken.access_token);*/

        /*const auchTocken = await service.initApp();
        console.log(auchTocken, '++++++++++')*/
console.log('VKUI init')
        const userInfo = await this.service.initApp()
            .catch((error) => {
                console.log('VkUI.init() error')
            });

        if (userInfo === undefined) {
            return Promise.reject();
        }

        console.log('this.userInfo', userInfo);
        const dbAuthToken = await this.service.getToken().catch(console.error);
        if (typeof dbAuthToken === 'string') {
            console.log(dbAuthToken);
            this.db.authWithToken(dbAuthToken);
        } else console.error('bad token', dbAuthToken);

        this._user = userInfo;/*{
            first_name: userInfo.first_name,
            last_name: userInfo.last_name,
            id: userInfo.id,
            access_token: auchTocken['access_token']
        }*/

        const avatar = PIXI.Sprite.from(userInfo['photo_100']);
        avatar.buttonMode = true;
        avatar.interactive = true;
        avatar.on('pointerdown', this.onClickSocial.bind(this));
        this.addChild(avatar);

        const back = new PIXI.Graphics();
        back.beginFill(0x000000, 0.7);
        back.drawRect(0, 0, 800, 500);
        this._cont.addChild(back);
        const fio = new PIXI.Text(
            `${this._user.first_name} ${this._user.last_name}, ID: ${this._user.id}`,
            {
                fill: 0xffffff,
                fontSize: 30,
                fontWeight: 'bold'
        });

        fio.x = 110;
        fio.y = 50 - fio.height / 2;
        this._cont.addChild(fio);
        //----------------------------------------------------
        const btnPost = new SocialButton('Пост', 0xff0000);
        btnPost.on('pointerdown', () => {
            this.service.postMessage('Привет, классная игра!', this.service.GAME_LINK); //todo: refactor
        });
        btnPost.x = back.width / 2 - btnPost.width / 2;
        btnPost.y = 100;
        this._cont.addChild(btnPost);

        const btnGetFriends = new SocialButton('Друзья', 0xff0000);
        btnGetFriends.on('pointerdown', async () => {
            const friendsList = await this.service.getFriends();
            console.log(friendsList);
            this._friendList.init(friendsList['response'].items);
        });
        btnGetFriends.x = btnPost.x;
        btnGetFriends.y = btnPost.y + btnPost.height + 5;
        this._cont.addChild(btnGetFriends);

        const btnPermissionNotification = new SocialButton('Уведомления', 0xff0000);
        btnPermissionNotification.on('pointerdown', async () => {
            try {
                const notification = await this.service.getAllowNotification();
                console.log(notification);
            } catch (e) {
                console.log('NOTIFICATION FAIL!!!');
            }


        });
        btnPermissionNotification.x = btnGetFriends.x;
        btnPermissionNotification.y = btnGetFriends.y + btnGetFriends.height + 5;
        this._cont.addChild(btnPermissionNotification);

        const btnInvite = new SocialButton('Пригласить', 0xff0000);
        btnInvite.on('pointerdown', async () => {
            await this.service.showInvite();
        });
        btnInvite.x = btnPermissionNotification.x;
        btnInvite.y = btnPermissionNotification.y + btnPermissionNotification.height + 5;
        this._cont.addChild(btnInvite);

        const btnFavorite = new SocialButton('Левая пан.', 0xff0000);
        btnFavorite.on('pointerdown', async () => {
            this.service.addToFavorite();
        })
        btnFavorite.x = btnInvite.x;
        btnFavorite.y = btnInvite.y + btnInvite.height + 5;
        this._cont.addChild(btnFavorite);

        const addGroup = new SocialButton('В сообщество', 0xff0000);
        addGroup.on('pointerdown', async () => {
            this.service.joinGroup();
        })
        addGroup.x = btnFavorite.x;
        addGroup.y = btnFavorite.y + btnFavorite.height + 5;
        this._cont.addChild(addGroup);

        const inviteOneUser = new SocialButton('Пригласить одного', 0xff0000);
        inviteOneUser.on('pointerdown', async () => {
            this.service.showInviteOneUser(249378474);
        })
        inviteOneUser.x = addGroup.x;
        inviteOneUser.y = addGroup.y + btnFavorite.height + 5;
        this._cont.addChild(inviteOneUser);

        this.addChild(this._friendList);

    }

    /*private async initApp() {
        const data = await bridge.send('VKWebAppInit');
        return data.result
    }

    // запрос токена для доступа к друзьям
    private async getAuthToken() {
        const auchToken = await bridge.send(
            "VKWebAppGetAuthToken",
            {
                app_id: this.APP_ID,
                scope: "friends,status"
            });
        return auchToken;
    }*/

    //информация о пользователе
    /*private async getUserInfo() {
        const userInfo = await bridge.send('VKWebAppGetUserInfo');
        return userInfo;
    }*/
    // пост себе на стену
    /*private async postMessage(message: string, attachments: string) {
         const postMEssage = await bridge.send("VKWebAppShowWallPostBox", {
            owner_id: this._user.id,
            message,
            attachments
          });
    }*/
    // список друзей
    /*private async getFriends() {
        const friends = await bridge.send('VKWebAppCallAPIMethod',
        {
            method: 'friends.get',
            request_id: Math.random(),
            params: {
                fields:"first_name,last_name,photo_100",
                access_token: this._user.access_token,
                v: '5.131'
            }
        });
        return friends;
    }*/
    // разрешение на отправку уведомлений
    /*private async getAllowNotification() {
       const notification = await bridge.send("VKWebAppAllowNotifications");
       return notification;
    }*/
    // пригласить друзей !!!!!!! РАБОТАЕТ ТОЛьКО ЕСЛИ ПРИЛОЖЕНИЕ УКАЗАНО КАК ИГРА
    /*private async showInviteBox() {
        bridge.send("VKWebAppShowInviteBox", {request_id: Math.random()})
         .then(data => console.log(data.success))
        .catch(error => console.log(error));
    }*/
    // отправить приглашение конкретному пользователю
    /*private async showInviteOneUser(uid: number) {
        bridge.send('VKWebAppShowRequestBox',
            {
                uid,
                message: 'Привет, посмотри какая классная игра',
                requestKey: `key: ${Math.random()}`
            })
        .then(data => console.log(data.success))
        .catch(error => console.log(error));
    }
    // добавление в левую панел
    private async addToFavorite() {
        const add = await bridge.send("VKWebAppAddToFavorites");
        return add;
    }

    // добавление в группу
    private async joinToGroup() {
        bridge.send("VKWebAppJoinGroup", {"group_id": this.GROUP_ID})
        .then(data => console.log(data.result))
        .catch(error => console.log(error));
    }
*/
    private onClickSocial() {
        this._cont.visible = !this._cont.visible;
    }
}


